"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILENAMES = void 0;
exports.FILENAMES = {
    pip: {
        manifest: 'requirementes.txt',
    },
    setuptools: {
        manifest: 'setup.py',
    },
    pipenv: {
        manifest: 'Pipfile',
        lockfile: 'Pipfile.lock',
    },
    poetry: {
        manifest: 'pyproject.toml',
        lockfile: 'poetry.lock',
    },
};
//# sourceMappingURL=types.js.map